module.exports = __webpack_public_path__ + "img/logo.3cc56f04.png";